import { createContext } from 'react';

import { IApis } from 'library/Apis';

import { UserManager } from 'oidc-client';

interface AppContext {
  currentEnv?: IApis;
  associadoManager: UserManager | null;
}

export default createContext<AppContext>({
  associadoManager: null,
});
